<template>
  <div class="block-stat-wrapper">
    <div class="block-stat-inner">
      <div class="bs-inner-left">
        <h1>{{ statInfo.title }}</h1>
        <p>{{ statInfo.value }}</p>
      </div>
      
      <div class="bs-inner-right">
        <slot name="block-icon"></slot>
      </div>
    </div>
    
  </div>
</template>

<script>

export default {
  props: {
    statInfo: {
      type: Object,
      required: true,
    },
    type: Boolean
  }
}
</script>

<style lang="scss" scoped>
.block-stat-wrapper {
  padding: 0 10px;

  .block-stat-inner {
    height: 82px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 15px 20px;
    border-radius: 8px;
    
    h1 {
      font-size: 14px;
      font-weight: 400;
      line-height: 22.4px;
    }

    p {
      font-size: 20px;
      font-weight: 600;
      line-height: 30px;
      margin-bottom: 0;
    }

    .bs-inner-right {
      span {
        width: 36px;
        height: 36px;
        display: block;

        img {
          display: inline-block;
        }
      }
    }
  }
}

.block-stat-wrapper:first-child {
  padding-left: 0;
}

.block-stat-wrapper:last-child {
  padding-right: 0;
}


</style>